import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DictionaryEvidence,
  FormSelect,
  useStaticListSource,
} from '@eas/common-web';
import { useCommonHistoryDescriptors } from '@composite/history/history-common-descriptors';
import { HistoryField } from '@composite/history/history-field';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';

export function Fields() {
  const historyDescriptors = useCommonHistoryDescriptors();

  const { agendas } = useContext(StaticDataContext);
  const agendasSource = useStaticListSource(agendas);

  return (
    <>
      <DictionaryEvidence.FieldName />
      <FormSelect
        name="agenda"
        label={
          <FormattedMessage
            id="ES__DICT_BRIEF_SUMMARIES__DETAIL__FIELD_LABEL__AGENDA"
            defaultMessage="Agenda"
          />
        }
        source={agendasSource}
        valueIsId
        required
      />
      <DictionaryEvidence.FieldActive />
      <DictionaryEvidence.FieldOrder />
      <HistoryField
        descriptors={[
          ...historyDescriptors,
          { key: 'agenda', label: 'Agenda' },
        ]}
      />
    </>
  );
}
